import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Spinner } from 'ui';
import languageMapper from 'utils/languageMapper';
import {
  getSeismicAuthToken,
  removeAuthTokenFromLocalStorage,
} from 'utils/centralAuthToken';

const UCP = lazy(() =>
  import(/* webpackChunkName: "UCP" */ '@seismic/universal-content-picker'),
);

const Loader = () => {
  return (
    <div className="SeismicContent--Spinner">
      <Spinner size="larger" />
    </div>
  );
};

const SeismicContentPicker = ({
  documentPicked,
  pickerSettings,
  repositories = ['doccenter'],
}) => {
  const [seismicToken, setSeismicToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const onTokenExpired = () =>
    new Promise(async resolve => {
      const token = await getSeismicAuthToken();
      if (token) {
        resolve({ isSuccess: true, token });
      } else {
        removeAuthTokenFromLocalStorage();
        resolve({ isSuccess: false });
      }
    });

  useEffect(() => {
    async function getToken() {
      const authToken = await getSeismicAuthToken();
      setSeismicToken(authToken);
      setLoading(false);
    }
    getToken();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="SeismicContentPicker">
      <Suspense fallback={<Loader />}>
        <UCP
          apiOptions={{
            authTokenResolver: () => seismicToken,
            onTokenExpired,
          }}
          settings={{
            repositories,
            selectionMode: 'single',
            allowFolderSelection: false,
            viewMode: 'wide',
            language: languageMapper(),
            application: 'Lessonly',
            showPreview: true,
            customizations: {
              preview: {
                displayPreviewOnContentIcon: true,
                displayPreviewOnPreviewButton: true,
                previewOnAction: 'click',
                triggerOnPreviewCallback: false,
                hideInbuiltPreview: false,
              },
            },
            ...pickerSettings,
          }}
          callbacks={{
            onSelectionChanged: items => {
              documentPicked(items);
            },
          }}
        />
      </Suspense>
    </div>
  );
};

export default SeismicContentPicker;
